import Cookies from 'js-cookie'

// По умолчанию включать светлую тему?
const darkModeDefaultLight = false;
//const darkModeDefaultLight = window.self !== window.top; // чтобы не мелькало в iframe (рейтинг рунета)

// Режим двухпозиционного переключения (системная/не системная тема)
const darkModeSystemToggle = false;

if (darkModeDefaultLight && !('theme' in localStorage)) {
    localStorage.theme = 'light';
}

window.checkDarkMode = function () {

    // Системная тема — темная?
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    let isSystem = false;
    let isDark = false;
    let isLight = false;

    if (localStorage.theme === 'dark' || !('theme' in localStorage) && prefersDark) {
        Cookies.set('dark', 1);
        document.documentElement.classList.add('dark')
        isDark = true;
    } else {
        Cookies.remove('dark');
        document.documentElement.classList.remove('dark')
        isLight = true;
    }

    if (localStorage.theme === 'auto' || !('theme' in localStorage)) {
        Cookies.set('color-scheme-system', 1);
        isSystem = true;
        isDark = false;
        isLight = false;
    } else {
        Cookies.remove('color-scheme-system');
    }

    if(isSystem){
        document.documentElement.classList.add('color-scheme-system');
        document.documentElement.classList.remove('color-scheme-dark');
        document.documentElement.classList.remove('color-scheme-light');
    }
    if(isDark){
        document.documentElement.classList.add('color-scheme-dark');
        document.documentElement.classList.remove('color-scheme-system');
        document.documentElement.classList.remove('color-scheme-light');
    }
    if(isLight){
        document.documentElement.classList.add('color-scheme-light');
        document.documentElement.classList.remove('color-scheme-system');
        document.documentElement.classList.remove('color-scheme-dark');
    }
}

window.setDarkMode = function (theme) {

    console.log('Set Color Scheme: ' + theme);

    // Системная тема — темная?
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (theme === 'auto') {
        localStorage.removeItem('theme');
    } else {
        localStorage.theme = theme;
    }

    // Режим двухпозиционного переключения - dark → auto
    if(darkModeSystemToggle && prefersDark && theme === 'dark'){
        localStorage.removeItem('theme');
    }

    // Режим двухпозиционного переключения - light → auto
    if(darkModeSystemToggle && !prefersDark && theme === 'light'){
        localStorage.removeItem('theme');
    }

    window.checkDarkMode();
}

window.toggleDarkMode = function () {

    console.log('Toggle Dark Mode');

    const currentTheme = localStorage.getItem('theme');

    if (currentTheme === 'light') {
        setDarkMode('dark');
        return;
    }

    if (currentTheme === 'dark' && !darkModeDefaultLight) {
        setDarkMode('auto');
        return;
    }

    setDarkMode('light');
}

window.matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', () => {
        window.checkDarkMode();
    })

window.checkDarkMode();
